import React, { useState } from "react";
import axios from "axios";
import config from "../config";

const AddChallenges = () => {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [task, setTask] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let validationErrors = {};
    if (!title.trim()) validationErrors.title = "Challenge Title is required";
    if (!message.trim()) validationErrors.message = "Challenge Message is required";
    if (!task.trim()) validationErrors.task = "Challenge Task is required";

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    setErrors({});

    try {
      const postData = {
        catId: 4, // Replace with your actual category ID
        prayerType: "challenge",
        title: title,
        description: message,
        numberOfTask: parseInt(task),
        reference: null,
        file: null,
      };

      const response = await axios.post(`${config.BASE_URL}/apis/create-post-admin`, postData);

      if (response.data.success) {
        alert("Challenge created successfully!");
        setTitle("");
        setMessage("");
        setTask("");
      } else {
        alert("Failed to create challenge: " + response.data.message);
      }
    } catch (error) {
      console.error("Error creating challenge:", error);
      alert("An error occurred while creating the challenge.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto mt-10 bg-white shadow-md rounded-md">
      <div className="bg-orange-500 text-white px-4 py-3 rounded-t-md">
        <h2 className="font-semibold">Add New Challenge</h2>
      </div>

      <div className="p-6">
        <form onSubmit={handleSubmit} noValidate>
          {/* Challenge Title */}
          <div className="mb-4">
            <label htmlFor="title" className="block text-gray-700 font-medium mb-1">
              Challenge Title
            </label>
            <input
              id="title"
              type="text"
              placeholder="Enter Challenge Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400 ${
                errors.title ? "border-red-500" : "border-gray-300"
              }`}
              disabled={loading}
            />
            {errors.title && <p className="text-red-500 text-sm mt-1">{errors.title}</p>}
          </div>

          {/* Challenge Message */}
          <div className="mb-4">
            <label htmlFor="message" className="block text-gray-700 font-medium mb-1">
              Challenge Message
            </label>
            <textarea
              id="message"
              placeholder="Enter Challenge Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400 resize-none ${
                errors.message ? "border-red-500" : "border-gray-300"
              }`}
              rows={3}
              disabled={loading}
            />
            {errors.message && <p className="text-red-500 text-sm mt-1">{errors.message}</p>}
          </div>

          {/* Challenge Task */}
          <div className="mb-6">
            <label htmlFor="task" className="block text-gray-700 font-medium mb-1">
              Challenge Task
            </label>
            <input
              id="task"
              type="number"
              placeholder="Enter Challenge No of Task"
              value={task}
              onChange={(e) => setTask(e.target.value)}
              className={`w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400 ${
                errors.task ? "border-red-500" : "border-gray-300"
              }`}
              disabled={loading}
            />
            {errors.task && <p className="text-red-500 text-sm mt-1">{errors.task}</p>}
          </div>

          {/* Add Button */}
          <button
            type="submit"
            disabled={loading}
            className={`bg-orange-500 text-white font-semibold px-6 py-2 rounded hover:bg-orange-600 transition ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {loading ? "Submitting..." : "Add"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddChallenges;
